import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes-components';

const ActiveLockBanner = ({ lockInfo }) => {
  if (!lockInfo) return null;
  
  const { userDisplayName, lockedSince } = lockInfo;
  const lockTime = new Date(lockedSince).toLocaleString();

  return (
    <div
      style={{
        padding: '12px 16px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderLeft: '4px solid #e17055',
        color: '#6c5ce7',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
        fontWeight: '400',
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: '0px',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <Icon icon="exclamation-triangle" size="medium" style={{ color: '#e17055' }} />
      <div>
        <FormattedMessage
          id="ui-plugin-inventory-templates.recordLock.forceEditWarning"
          defaultMessage="⚠️ تحذير: أنت تقوم بالتحرير على مسؤوليتك الشخصية - هذه التسجيلة مستخدمة من قبل {user} منذ {time}"
          values={{
            user: <strong style={{ color: '#2d3436', fontWeight: '600' }}>{userDisplayName}</strong>,
            time: <strong style={{ color: '#636e72', fontWeight: '500' }}>{lockTime}</strong>,
          }}
        />
      </div>
    </div>
  );
};

ActiveLockBanner.propTypes = {
  lockInfo: PropTypes.shape({
    userDisplayName: PropTypes.string.isRequired,
    lockedSince: PropTypes.number.isRequired,
  }),
};

export default ActiveLockBanner;
